import fb from "../Assets/Indorinama-website-elements/Icons/fb.svg";
import insta from "../Assets/Indorinama-website-elements/Icons/ig.svg";
import lid from "../Assets/Indorinama-website-elements/Icons/linkedin.svg";
import twi from "../Assets/Indorinama-website-elements/Icons/twitter.svg";
import pin from "../Assets/Indorinama-website-elements/Icons/pinterest.svg";
import you from "../Assets/Indorinama-website-elements/Icons/youtube.svg";
import loc from "../Assets/location-svgrepo-com (1) 1.svg";
import call from "../Assets/call-192-svgrepo-com 1.svg";
import email from "../Assets/email-svgrepo-com 1.svg";
import iso from "../Assets/Indorinama-website-elements/Icons/ISO.svg";
import intelectual from "../Assets/Indorinama-website-elements/Icons/IPI.svg";
import msme from "../Assets/Indorinama-website-elements/Icons/MSME.svg";
import { NavLink } from "react-router-dom";
import { LuArrowUp } from "react-icons/lu";

const socials = [
  { href: "https://www.facebook.com/indorinama/", src: fb, alt: "Facebook" },
  { href: "https://www.instagram.com/indorinama", src: insta, alt: "Instagram" },
  { href: "https://www.linkedin.com/company/indorinama", src: lid, alt: "LinkedIn" },
  { href: "https://twitter.com/indorinama", src: twi, alt: "Twitter" },
  { href: "https://in.pinterest.com/indorinama/", src: pin, alt: "Pinterest" },
  {
    href: "https://www.youtube.com/channel/UCdTfsY-KcBR3oZZOEWK_7Iw",
    src: you,
    alt: "YouTube",
  },
];

const serviceLinks = [
  { to: "/advertising", label: "Advertising" },
  { to: "/designing", label: "Designing" },
  { to: "/printing", label: "Printing" },
  { to: "/digital-marketing", label: "Digital Marketing" },
];

const companyLinks = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/my-orders", label: "My Orders" },
  { to: "/cart", label: "My Cart" },
];

const legalLinks = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms-and-conditions", label: "Terms & Conditions" },
  { to: "/refund-cancellation", label: "Refund & Cancellation" },
];

const SectionTitle = ({ children }) => (
  <h5 className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.22em] text-white/40">
    <span className="h-px w-5 shrink-0 bg-[#bc1535]" aria-hidden="true" />
    <span>{children}</span>
  </h5>
);

function Footer() {
  return (
    <footer className="relative overflow-hidden bg-[#161310] text-[#f5efe8]">
      {/* Red glow accents */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage:
            "radial-gradient(800px 300px at 85% 0%, rgba(188,21,53,0.18), transparent 60%), radial-gradient(600px 300px at 0% 100%, rgba(188,21,53,0.10), transparent 60%)",
        }}
      />
      {/* Thin red top hairline */}
      <div aria-hidden="true" className="h-[2px] bg-gradient-to-r from-transparent via-[#bc1535] to-transparent" />

      <div className="relative mx-auto max-w-7xl px-4 pt-10 sm:px-6 sm:pt-12 lg:px-8">
        <div className="grid grid-cols-2 gap-x-6 gap-y-10 lg:grid-cols-12">
          {/* Brand */}
          <div className="col-span-2 lg:col-span-5">
            <NavLink to="/" className="inline-block no-underline">
              <img src="/in-logo-full-2.svg" alt="Indorinama Logo" className="h-12 w-auto sm:h-14" />
            </NavLink>
            <p className="mt-4 max-w-md text-sm leading-6 text-white/60">
              Our vision is simply to be the best advertising agency — using
              insights, experience, creativity and business sense to grow our
              clients&apos; profits in a sustainable way.
            </p>
            <div className="mt-5 flex flex-wrap gap-2.5">
              {socials.map((s) => (
                <a
                  key={s.alt}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.alt}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white transition hover:-translate-y-0.5 hover:border-[#bc1535] hover:bg-[#bc1535]"
                >
                  <img src={s.src} alt={s.alt} className="h-4 w-4" />
                </a>
              ))}
            </div>
            <div className="mt-6 flex items-center gap-4">
              <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/35">
                Certified
              </span>
              <img src={intelectual} alt="Intellectual Property" className="h-9 w-9 opacity-90" />
              <img src={iso} alt="ISO" className="h-9 w-9 opacity-90" />
              <img src={msme} alt="MSME" className="h-9 w-9 opacity-90" />
            </div>
          </div>

          {/* Services */}
          <div className="lg:col-span-2">
            <SectionTitle>Services</SectionTitle>
            <ul className="m-0 mt-4 space-y-2.5 p-0 list-none">
              {serviceLinks.map((l) => (
                <li key={l.to}>
                  <NavLink
                    to={l.to}
                    className="inline-block text-sm text-white/65 no-underline transition hover:translate-x-0.5 hover:text-[#ff8ca0]"
                  >
                    {l.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="lg:col-span-2">
            <SectionTitle>Company</SectionTitle>
            <ul className="m-0 mt-4 space-y-2.5 p-0 list-none">
              {companyLinks.map((l) => (
                <li key={l.to}>
                  <NavLink
                    to={l.to}
                    className="inline-block text-sm text-white/65 no-underline transition hover:translate-x-0.5 hover:text-[#ff8ca0]"
                  >
                    {l.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-2 lg:col-span-3">
            <SectionTitle>Get in touch</SectionTitle>
            <ul className="m-0 mt-4 space-y-3.5 p-0 list-none text-sm">
              <li>
                <a
                  href="https://www.google.com/maps/dir//indorinama,+international+school,+478+royal+krishna+colony+near+emerald+heights,+Indore,+Madhya+Pradesh+453331/@22.8243904,74.8839549,10z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3962fd48018a185f:0x331f923f98609c0b!2m2!1d75.8177966!2d22.6521303?entry=ttu"
                  className="flex items-start text-white/65 no-underline transition hover:text-white"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={loc} alt="location" className="mr-2 mt-0.5 h-5 w-5 shrink-0" />
                  <span>
                    206, 2nd Floor Samiksh Landmark,
                    <br />
                    Near Choithram Square,
                    <br />
                    Indore (M.P.) 452001
                  </span>
                </a>
              </li>
              <li className="flex items-center gap-2 text-white/65">
                <img src={call} alt="call" className="h-5 w-5 shrink-0" />
                <a href="tel:+9107314959590" className="text-white/65 no-underline transition hover:text-white">
                  0731-4959590
                </a>
                <span className="text-white/30">/</span>
                <a href="tel:+918989801088" className="font-semibold text-white no-underline transition hover:text-[#ff8ca0]">
                  8989 8010 88
                </a>
              </li>
              <li>
                <a
                  href="mailto:help@indorinama.in"
                  className="flex items-center text-white/65 no-underline transition hover:text-white"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={email} alt="email" className="mr-2 h-5 w-5 shrink-0" />
                  help@indorinama.in
                </a>
              </li>
              <li>
                <p className="mb-2 text-[10px] font-bold uppercase tracking-[0.2em] text-white/35">
                  Available on
                </p>
                <img src="/footer_logos.svg" alt="Marketplace presence" className="h-auto max-w-full opacity-90" />
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 flex flex-col items-center gap-3 border-t border-white/10 py-5 text-center sm:flex-row sm:justify-between sm:text-left">
          <p className="m-0 text-xs text-white/45">
            Made in India © Indorinama {new Date().getFullYear()}, All rights reserved
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            {legalLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className="text-xs text-white/55 no-underline transition hover:text-white"
              >
                {l.label}
              </NavLink>
            ))}
            <button
              type="button"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              aria-label="Back to top"
              className="flex h-8 w-8 items-center justify-center rounded-full border border-white/15 text-white/70 transition hover:-translate-y-0.5 hover:border-[#bc1535] hover:bg-[#bc1535] hover:text-white"
            >
              <LuArrowUp className="text-sm" />
            </button>
          </div>
        </div>
      </div>

      {/* Giant watermark wordmark — kept small */}
      <div aria-hidden="true" className="pointer-events-none relative select-none overflow-hidden">
        <img
          src="/in-logo-full-2.svg"
          alt=""
          className="mx-auto -mb-3 w-[min(520px,80%)] max-w-none opacity-10 sm:-mb-4"
        />
      </div>
    </footer>
  );
}

export default Footer;
